export default "__VITE_ASSET__CynA53os__"